import { useKey } from './useKey.js';

/**
 * useKeyBindings
 *
 * useKeyBindings binds pairs of keyboard events and handlers
 *
 * @param { KeyBindings } keyBindings
 * @param {Options} options
 * @see https://rooks.vercel.app/docs/useKeyBindings
 */
const useKeyBindings = (keyBindings, options) => {
    for (const key in keyBindings) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useKey(key, keyBindings[key], options);
    }
};

export { useKeyBindings };
